import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@mui/material';
import debounce from 'lodash.debounce';
import { StyledTableCell } from './styledTableComponent';

export default function PolicyTableCheckboxCell(props) {
  const {
    name, onChange, isDisabled, isComparePlans,
  } = props;

  const {
    control, getValues, setValue, trigger,
  } = useFormContext();

  return (
    <StyledTableCell align="left" component="th" scope="row" isComparePlans={isComparePlans}>
      <Controller
        name={name}
        control={control}
        defaultValue={isComparePlans ? true : getValues(name)}
        render={({ field, fieldState: { error } }) => (
          <Checkbox
            id={`input_${name}`}
            {...field}
            fullWidth
            error={error}
            helperText={error ? error.message : null}
            checked={field.value}
            onChange={(event) => {
              setValue(name, event.target.value === 'false' || event.target.value === false);
              field.onChange(event.target.checked);
              setTimeout(
                debounce(() => {
                  trigger('heartAttackChecked');
                  onChange();
                }, 100),
              );
            }}
            disabled={isDisabled}
          />
        )}
      />
    </StyledTableCell>
  );
}
